<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Recuperar Senha</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-form form @submit.prevent="onRecover">
                        <v-card-text>
                            <v-text-field id="email" prepend-icon="person" v-model="email" name="email" label="Email" :rules="[rules.email]"
                            type="text"></v-text-field>
                            <!---<div class="g-recaptcha" data-sitekey="6LdIIK8UAAAAACgAZb7PGFsdu542zhE4V836mvle" data-type="image"></div>-->
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="mr-2 mb-2" @click="recuperar" color="primary">Enviar</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>

    export default {
        name: 'RecuperarSenha',
        data() {
            return {
                email: '',
                rules: {
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'E-mail inválido.'
                    }
                }
            }
        },
        computed:{
            retorno: function () {
                return this.$store.getters.getRetorno
            }
        },
        methods: {
            onRecover() {
                /*if (grecaptcha && grecaptcha.getResponse().length > 0) {
                    let data =  {email: this.email}
                    this.$store.dispatch('recoverPassword', data)
                } else {
                    alert('Você precisa realizar a verificação!');
                }*/
            }, 
            recuperar() {
                this.$store.dispatch('recoverPassword', {email: this.email})
            }
        },
        watch:{
            retorno: function () {
                if(this.retorno){
                    this.$router.push({
                        name:'Signin'
                    })
                }
            }
        }
    }
</script>
